import jwtDecode from "jwt-decode";

export const hasValidToken = () => {
  const token = localStorage.getItem("token");
  try {
    var decoded = jwtDecode(token);
    // Check and see if the token is valid

    if (!isTokenExpired(decoded)) {
      return true;
    }
  } catch (e) {
    return false;
  }
  return false;
};

export const redirectToDashboard = () => {
  // if (toCF) {
  //   console.log("r2c");
  //   window.location.href = (process.env.NODE_ENV === "production"
  //     ? window.SOLO.env
  //     : process.env
  //   ).REACT_APP_DASHBOARD;
  // } else {
  //   console.log("r2s");
  window.location.href = (
    process.env.NODE_ENV === "production" ? window.SOLO.env : process.env
  ).REACT_APP_DASHBOARD;
  // }
  // window.location.href = "/";
};

export const redirectToVerification = () => {
  window.location.href = "/id/verification";
};

function isTokenExpired(token) {
  const expiresAt = token.exp;
  const now = Math.floor(new Date().getTime() / 1000);
  if (now > expiresAt) {
    return true;
  } else {
    return false;
  }
}

// export const setSSOToken = (token) => {
//   var el = document.createElement("iframe");
//   el.setAttribute("style", "display: none;");
//   el.setAttribute("src", process.env.REACT_APP_SSO_PARTNER + "?token=" + token);
//   el.onload = function () {
//     document.body.removeChild(el);
//   };
//   document.body.appendChild(el);
// };

// export const revokeSSOToken = () => {
//   var el = document.createElement("iframe");
//   el.setAttribute("style", "display: none;");
//   el.setAttribute("src", process.env.REACT_APP_SSO_PARTNER + "?token=" + "");
//   el.onload = function () {
//     document.body.removeChild(el);
//   };
//   document.body.appendChild(el);
// };
